import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import Button from "components/ui/button/Button";
import { NotFoundCloud } from "./NotFoundCloud";

/**
 * The router's not-found screen, rendered for any in-app path no route matches.
 *
 * Wired as TanStack Router's `defaultNotFoundComponent` (see `router/routes.tsx`).
 * Rails answers the wildcard SPA prefixes (`/suppliers/*path` and friends) with
 * the shell at HTTP 200, so before this existed a bad app URL rendered the
 * router's bare built-in "Not Found" text inside the AppShell.
 *
 * Anonymous visitors on a URL matching no Rails route at all still get the
 * static `public/404.html`, which is a separate surface.
 */
export function NotFoundPage() {
  return (
    <Wrapper column alignItems="center" justifyContent="center" gap="24px">
      <NotFoundCloud />
      <Flex column alignItems="center" gap="8px">
        <Text h2>Page not found</Text>
        <Lead description center>
          We can't find that page. The link may be out of date, or what it pointed to may no longer
          be listed.
        </Lead>
      </Flex>
      {/* Router link, not an href: this renders inside RouterProvider, so a
          full page reload would be a needless round trip. */}
      <Button buttonType="primary" as="a" to="/">
        Back to home
      </Button>
    </Wrapper>
  );
}

const Wrapper = styled(Flex)({
  maxWidth: "480px",
  margin: "0 auto",
  padding: "64px 16px",
  textAlign: "center",
});

const Lead = styled(Text)({
  maxWidth: "42ch",
});
